import React from "react";

import LandingHeader from "pages/landing/includes/LandingHeader";
import LandingFooter from "pages/landing/includes/LandingFooter";

class Privacy extends React.Component {

    render() {
        return (
            <>
                <LandingHeader />

                <div className="about-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="about-items">
                                <div className="col-md-12 about-info">
                                    <h2><span>Privacy Policy</span></h2>
                                    <blockquote>We does not store any confidential information of any user.</blockquote>
                                    <blockquote>We store cookies which are solely on consent by users.</blockquote>
                                    <blockquote>Users personal data are stored privately and are not shared to any third party.</blockquote>
                                    <blockquote>Passwords are always encrypted and is not available to anyone and are secure.</blockquote>
                                    <blockquote>All data collected are by user's consent.</blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LandingFooter />
            </>
        );
    }
}

export default Privacy;
